import { type RefreshMutation, type SessionDataQuery } from "@/gql/graphql";

export const RS_API_URI = process.env.NODE_ENV === "production" ? "/api/v2" : "http://localhost:8000/api/v2";

export type UserResponseType = SessionDataQuery["sessionData"] | RefreshMutation["refresh"];

export class AuthenticationError extends Error {}
